module.exports = __webpack_public_path__ + "img/DiNapoli-5.41681d95.jpg";